import { defineMessages } from 'react-intl';

const definedMessages = defineMessages({
  youClockedIn: {
    id: 'app.timeclock.clockin.you_clocked_in',
    description: 'Message when first clocking in',
    defaultMessage: 'You clocked in at',
  },
  soWhatsNext: {
    id: 'app.timeclock.clockin.so_whats_next',
    description: 'Telling the user what the next steps are',
    defaultMessage: 'So, what\'s next?',
  },
  loginToTandaHeading: {
    id: 'app.timeclock.clockin.login_to_tanda_heading',
    description: 'Prompting user to login',
    defaultMessage: ' View your timesheet',
  },
  loginToTandaBody: {
    id: 'app.timeclock.clockin.login_to_tanda_body',
    description: 'More info on Tanda',
    defaultMessage: 'Your clock in has started a shift in My Tanda.',
  },
  keepClockingIn: {
    id: 'app.timeclock.clockin.git_it',
    description: 'Keep clocking in',
    defaultMessage: 'Keep clocking in',
  },
  seeMyTimesheet: {
    id: 'app.timeclock.clockin.login_to_tanda_now',
    description: 'Calling user to login now',
    defaultMessage: 'See my timesheet',
  },
});

export default definedMessages;



// WEBPACK FOOTER //
// ./src/components/timeclock/userhub/home/ClockIn/i18n.js